export const GET_ORDER_DETAILS_V2 = `/v2/orders/{{StoreId}}/{{language}}/orderdetails/{{currentOrderID}}`;
export const GET_EARNED_POINTS = `/v2/carts/{{StoreId}}/{{language}}/current/loyalty-points?fields=OPTIMIZEDCART&areacode={{areaCode}}&checkoutType={{checkoutType}}&isLoyaltyApplied={{isLoyaltyApplied}}&nsp={{nsp}}`;

export const SEND_ORDERID_TO_CITRUS = '/v1/sponsored/report/orders';

export const GET_SECONDARY_STATUS = `/payments/{{StoreId}}/{{language}}/split/check-status?orderId={{currentOrderID}}`;
export const GET_TRANSACTION_STATUS = `/payments/transactions`;
